module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', _vm._b({
    attrs: {
      "fullscreen": _vm.$dayspan.fullscreenDialogs
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, 'v-dialog', _vm.dialogProps, false), [(_vm.hasData) ? _c('v-card', [_vm._t("scheduleTypeCustomHeader", null, null, {
    original: _vm.original,
    copy: _vm.copy,
    aroundDay: _vm.aroundDay,
    day: _vm.day
  }), _vm._v(" "), _c('v-card-text', [_vm._t("scheduleTypeCustomBody", [_c('ds-schedule-type-custom', {
    attrs: {
      "schedule": _vm.copy,
      "day": _vm.aroundDay
    }
  })], null, {
    original: _vm.original,
    copy: _vm.copy,
    aroundDay: _vm.aroundDay,
    day: _vm.day
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_vm._t("scheduleTypeCustomActions", [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.cancel)
    }
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.save)
    }
  })])], null, {
    original: _vm.original,
    copy: _vm.copy,
    aroundDay: _vm.aroundDay,
    day: _vm.day,
    cancel: _vm.cancel,
    save: _vm.save,
    labels: _vm.labels
  })], 2)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de56f61c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleTypeCustomDialog.vue
// module id = 428
// module chunks = 1